import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Spinner } from "react-bootstrap";

export const LoadingSpinner = forwardRef(({ exportSpinner = false, size = "sm" }, ref) => {
  const [loadingSpinner, setLoadingSpinner] = useState(false);

  const showSpinner = () => {
    setLoadingSpinner(true);
  };

  const hideSpinner = () => {
    setLoadingSpinner(false);
  };

  // Expose the functions to the parent component using useImperativeHandle
  useImperativeHandle(ref, () => ({
    showSpinner,
    hideSpinner,
  }));

  return (
    <>
      {loadingSpinner && (
        <div className={exportSpinner ? "export-background-hide" : "background-hide"}>
        <Spinner
          animation="grow"
          size={size}
          className={exportSpinner ? "spinner-export" : "small-spinner"}
          />
          </div>
      )}
    </>
  );
});
